$(function(){

var pagetop = $('.footer-top-btn');
pagetop.hide();
$(window).scroll(function () {
if ($(this).scrollTop() > 100) {
pagetop.fadeIn();
} else {
pagetop.fadeOut();
}
});
pagetop.click(function () {
$('body, html').animate({ scrollTop: 0 }, 200);
return false;
});



// //modaal
// if ($(".modal_contents").length > 0) {
//     $(".modal_contents").modaal({
//         animation_speed: 100,
//         background: '#CCC',
//         overlay_opacity: 0.9
//     });
//     $('.btn_modal_close').click(function(){
//         $('.modal_contents').modaal('close');
//     });
// }








});//ready





$(window).load(function(){


/* Humbergar Menu */
$(".hmenu,.hmenu-back,.hmenu-nav a").on("click",hbgFunc);
var bodyHeight = $("#all").height();
$(".hmenu-back").height(bodyHeight);
function hbgFunc(){
$(".hmenu1").toggleClass("hmenuclick1");
$(".hmenu2").toggleClass("hmenuclick2");
$(".hmenu3").toggleClass("hmenuclick3");
$(".hmenu-nav").fadeToggle();
$("article").toggleClass("opacity20");
$(".fv").toggleClass("opacity20");
$(".hmenu-back").fadeToggle() ;
}


// Open Contents - accordion
$(".open_trigger").click(function(){
$(this).toggleClass("current");
$(this).next(".open_contents").slideToggle("200");
});







}); //load




